export function sumMetrics(metrics) {
  return metrics.reduce((a, c) => {
    a[c.groupIdentifier || c.identifier] += parseInt(c.value);
    return a;
  }, {"total.count": 0, "total.time": 0});
}
